;(() => {
  const html = document.documentElement
  const store = (name) => window.Alpine?.store?.(name) || window._stores?.[name]
  const inMenuSearch = (modal) =>
    typeof modal?.id === 'string' && modal.id.startsWith('megamenu--') && modal.sub_id === 'search'

  const focusSearch = () => {
    let n = 0
    const tick = () => {
      if (!html.classList.contains('menu-search-view')) return
      const input = [...document.querySelectorAll('[data-modal-id="search"] input[name="q"], [data-modal-id="search"] input[type="search"]')].find(
        (el) => el.getBoundingClientRect().width > 0
      )
      if (input) {
        input.focus({ preventScroll: true })
        if (document.activeElement === input) return
      }
      if (n++ < 30) requestAnimationFrame(tick)
    }
    window.Alpine?.nextTick?.(tick) || tick()
  }

  const closeSearch = () => {
    const modal = store('modal')
    if (modal?.sub_id === 'search') modal.setSubId('')
    const search = store('search')
    if (search) search.query = ''
    html.classList.remove('menu-search-view')
  }

  window.__openMenuSearch = (el, modal) => {
    if (window.innerWidth >= 768 || !modal || !el?.closest('[data-megamenu]')) return
    html.classList.add('menu-search-view')
    if (modal.sub_id !== 'search') modal.setSubId('search')
    focusSearch()
  }

  document.addEventListener(
    'click',
    (event) => {
      if (!html.classList.contains('menu-search-view')) return
      if (!event.target.closest?.('.js-menu-search-close')) return
      event.preventDefault()
      event.stopImmediatePropagation()
      closeSearch()
    },
    true
  )

  const watch = () => {
    const modal = store('modal')
    if (!window.Alpine?.effect || !modal || watch.bound) return
    watch.bound = true
    window.Alpine.effect(() => {
      void modal.id
      void modal.sub_id
      if (inMenuSearch(modal)) {
        html.classList.add('menu-search-view')
        focusSearch()
      } else if (html.classList.contains('menu-search-view')) closeSearch()
    })
  }

  document.addEventListener('alpine:init', watch)
  document.addEventListener('modalsLoaded', watch)
  watch()
})()
